export default {
	title: 'Elementos desactivados',
	empty: 'No hay elementos desactivados en este escenario',
	no_scenario: 'Seleccione un escenario para ver los elementos desactivados'
};

